function allStorageSelections() {
  // $("#storage-icons > div > a").each(function () {
  //   $("<input>", {
  //     name: "list_options[]",
  //     value: $(this).data("key"),
  //     type: "hidden",
  //   }).prependTo("form#search-location-form");
  // });
}

allStorageSelections();

$("#storage-icons > div > a").on("click", function (e) {
  e.preventDefault();
  let state = $(this).data("state");

  $(this).toggleClass("toggle-shadow");

  $(this).data("state", state == "off" ? "on" : "off");

  $('input[name="list_options[]"]').remove();
  $("#storage-icons > div > a").each(function () {
    let state = $(this).data("state");
    let key = $(this).data("key");

    if (state == "on") {
      $("<input>", {
        name: "list_options[]",
        value: key,
        type: "hidden",
      }).prependTo("form#search-location-form");
    }
  });

  if ($('input[name="list_options[]"]').length === 0) {
    allStorageSelections();
  }
});

let states = undefined;
async function getStates() {
  let { data } = await axios.post("helper/states");
  states = data;
}

$("select[name='state']").on("change", async function (e) {
  if (!states) {
    await getStates();
  }
  $("select[name='city']").prop("disabled", true).empty();
  $("select[name='type']").prop("disabled", true);
  $("select[name='city']").append($("<option/>").val("").text("Choose a city"));
  if ($(this).val() !== "") {
    try {
      let state = states.find((state) => {
        return state.slug === $(this).val();
      });
      let { data } = await axios.post("helper/cities", { state: state.abbr });
      $("select[name='city']").prop("disabled", false);
      $.each(data, (index, city) => {
        $("select[name='city']").append($("<option/>").val(city.slug).text(city.name));
      });
    } catch (error) {}
  }
});

$("select[name='city']").on("change", function (e) {
  $("select[name='type']").prop("disabled", !$(this).val().length);
});

$("#browse-by-form").validate({
  submitHandler: function (form) {
    let state = $("select[name='state']").val();
    let city = $("select[name='city']").val();
    let url = "/find-storage/" + state;
    if (city.length > 0) {
      url += "/" + city;
    }
    location.href = url;
  },
});
